function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3",
    "data-name": "Ebene 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0C3.58,0,0,.5,0,4v9.5A3.50386,3.50386,0,0,0,3.5,17L2,18.5V19H14v-.5L12.5,17A3.50386,3.50386,0,0,0,16,13.5V4C16,.5,12.42,0,8,0ZM3.5,15A1.5,1.5,0,1,1,5,13.5,1.498,1.498,0,0,1,3.5,15Zm9,0A1.5,1.5,0,1,1,14,13.5,1.498,1.498,0,0,1,12.5,15Zm.943-6H2.557A.557.557,0,0,1,2,8.443V4C2,1.09251,14,1.09251,14,4V8.443A.557.557,0,0,1,13.443,9Z",
    style: {
      fill: "#3c3c3b"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.b8a4f44322e2c1f7670955930f281821.svg";
export { ForwardRef as ReactComponent };